/**
 * 图片特效格式刷数据事务
 *
 * 复制可编辑特效配置到目标图片图层，正式渲染产物交给统一 render 重新生成。
 */
import { cloneDeep } from 'lodash';
import { type IFramework } from '@/framework';
import { LayerType, type IBorderRadiusProps, type IImageEffectProps, type IImageLayerProps } from '@/version-types';
import type { ImageLayer } from '../..';

/** 图片格式刷可复制的用户配置，不包含可信的特效渲染产物。 */
export type ImageBrushEffectData = {
    effect?: IImageEffectProps | null;
    borderRadius?: IBorderRadiusProps | null;
    opacity?: number;
};

/**
 * 把图片特效格式应用到目标图层
 *
 * @param framework - 编辑器框架
 * @param imageLayer - 图片图层数据事务实例
 * @param targetLayerId - 目标图片图层 ID
 * @param effectData - 来源图片的可编辑效果数据
 * @returns 是否成功找到并提交目标图片图层
 */
export async function applyImageBrushEffect(
    framework: IFramework,
    imageLayer: ImageLayer,
    targetLayerId: string,
    effectData: ImageBrushEffectData,
) {
    const oldLayer = framework.service.flatLayer.getLayer(targetLayerId, true);
    if (!oldLayer || oldLayer.layerType !== LayerType.IMAGE_LAYER) return false;

    const nextLayer = cloneDeep(oldLayer);
    const nextLayerData = nextLayer.data as IImageLayerProps;
    nextLayer.opacity = effectData.opacity ?? 1;
    nextLayerData.borderRadius = cloneDeep(effectData.borderRadius);
    const nextEffect = cloneDeep(effectData.effect);
    if (nextEffect) {
        nextEffect.screenshotUrl = '';
        delete nextEffect.effectPosition;
    }
    nextLayerData.effect = nextEffect;

    await imageLayer.updateLayer(nextLayer, oldLayer, true);
    return true;
}
